import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useTranslations } from "@src/packages/i18n";
import type { YouStackParamList } from "../../../types";
import { useYouScreen } from "../YouScreenContext";
import Preferences from "../sections/Preferences";
import YouDetailScreenLayout from "../components/YouDetailScreenLayout";
import { useSmartBack } from "../../../hooks/useSmartBack";

type Props = NativeStackScreenProps<YouStackParamList, "PreferencesSettings">;

export default function PreferencesSettingsScreen(_props: Props) {
  const handleBack = useSmartBack({
    fallbackTab: "Profile",
    fallbackScreen: "YouOverview",
  });
  const t = useTranslations();
  const { dispatch, preferences, preferencesStatus } = useYouScreen();

  return (
    <YouDetailScreenLayout
      title={t("you.panel_titles.preferences")}
      onBack={handleBack}
    >
      <Preferences
        preferences={preferences}
        status={preferencesStatus}
        dispatch={dispatch}
      />
    </YouDetailScreenLayout>
  );
}
